import { useSelector } from 'react-redux';
import { areAdsEnabled, shouldHideAds } from '../../config/adConfig';

export default function useHideAds() {
  return useSelector((state) => {
    if (!areAdsEnabled()) return true;
    const { authorized, user } = state.users.user;
    // Hold ads back while a stored token is still being validated, so paid users don't see a flash of ads
    if (!authorized && localStorage.getItem('token')) return true;
    return shouldHideAds(user);
  });
}
